import gsap from "gsap";

export default class InPageNavigationController {

    constructor() {
        this.init();
    }

    init() {

        let inPageMobileNav = document.querySelector(".js-in-page-navigation-mobile");
        let inPageMobileCurrent = document.querySelector(".js-in-page-navigation-mobile-current");
        let inPageMobileList = document.querySelector(".js-in-page-navigation-mobile-list");

        if (inPageMobileNav === null) {
            return;
        }

        inPageMobileCurrent.addEventListener("click", () => {

            if (!inPageMobileCurrent.classList.contains("is-active")) {
                inPageMobileCurrent.classList.add("is-active");
                gsap.to(inPageMobileList, {
                    autoAlpha: 1,
                });
            } else {
                inPageMobileCurrent.classList.remove("is-active");
                gsap.to(inPageMobileList, {
                    autoAlpha: 0,
                });
            }

        });

    }

}
